module.exports = __webpack_public_path__ + "img/Burkina Faso.7919005f.gif";